import { useMagasinStore } from "@/store/magasin";
import { useDatalayerStore } from "@/store/datalayer";
import { usePanierStore } from "@/store/panier";
import panierMapper from "@/services/panier/panier-mapper";
import { useUpdateCartTracking } from "@/mixins/tracking/update-cart";

export const pageMonCompteMesCommandesDetailsProduitsProps = () => ({
  commande: {
    type: Object,
    required: true
  },
  meta: {
    type: Object,
    required: true
  }
})

export const usePageMonCompteMesCommandesDetailsProduits = (props) => {


  const { trackUpdateCart } = useUpdateCartTracking();

  const magasinStore = useMagasinStore()
  const panierStore = usePanierStore()
  const datalayerStore = useDatalayerStore()

  const isLoading = ref(false)
  const titre = ref(null)

  const { isNational } = storeToRefs(magasinStore)

  const { displayStoreLocator } = magasinStore;
  const { setStoreLocatorContext } = datalayerStore;
  const { addCommandeToPanier, addListeProduitsToPanier } = panierStore;

  const nomCommande = computed(() => {
    if (titre.value) {
      return titre.value;
    } else if (props.commande) {
      return props.commande.attributes.titre;
    }
    return "";
  })

  const addToCartCommande = async () => {
    if (isNational.value) {
      displayStoreLocator();
      return;
    }
    try {
      isLoading.value = true;
      await addCommandeToPanier({ id: props.commande.id, typePanier: props.commande.attributes.type_panier });
    } finally {
      isLoading.value = false;
    }
  }

  const addToCartProduits = (produits) => {
    if (isNational.value) {
      displayStoreLocator();
      return;
    }
    try {
      isLoading.value = true;
      addListeProduitsToPanier(produits);
      trackUpdateCart({
        products: produits.map(product => (
          {
            ...panierMapper.getArticleModel(product.attributes.produit.data),
            quantity: product.attributes.quantite
          }
        )),
        method: "add",
        context: `${trackingCodes.LABELGA.AnciennesCommandes}${trackingCodes.CONTEXTPANIER.CommanderAnouveau}`
      });
    } finally {
      isLoading.value = false;
    }
  }

  const nameChanged = (t) => {
    titre.value = t;
    renommerRef.value.hide();
  }

  const mounted = () => {
    setStoreLocatorContext('commandes')
  }

  return {
    isLoading,
    titre,
    nomCommande,
    addToCartCommande,
    addToCartProduits,
    nameChanged,
    mounted
  }

}